const CopyrightText = () => (
    <>
        Copyright © Dr. Hart Labs - 2025 All Rights Reserverd
    </>

);

export default CopyrightText;